exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".language-selector__button{display:flex;flex-direction:row;align-items:center}.language-selector__button__text{color:var(--black);font-size:var(--font-medium);margin-right:5px}.language-selector__button__icon{width:10px}.language-selector__button__icon path{fill:var(--black)}", ""]);

// exports
